var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex-1 flex flex-col items-center main-content",style:(_vm.maxHeight ? { maxHeight: _vm.maxHeight } : null)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }